import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { formatImageAlt } from "../../../shared/utils/stringUtilities";

import "./categoryRecommendedBody.scss";

const CategoryRecommendedBody = ({ iconType, type, sectionTitle, content }) => {
  const imageType = () => {
    switch (type) {
      case "cuadrado":
        return "squared";
      case "vertical":
        return "vertical";
      case "circular":
        return "circular";
      default:
        return "horizontal";
    }
  };

  const renderBody = () => {
    return (
      <div className="m-category-recommended__body-container">
        <span className="m-category-recommended__body-container__title">
          {sectionTitle}
        </span>
        {content.map((item, index) => (
          <div
            key={`recommendedCard-${index}`}
            className="m-category-recommended__body-container__content"
          >
            <div className="m-category-recommended__body-container__content-image">
              <img
                src={item.imagenPrincipal[0].file.url}
                className={`m-category-recommended__body-container__content ${imageType()}-image`}
                alt={formatImageAlt(item.imagenPrincipal[0].file.fileName.replace(/.jpg/, "").replace(/.png/, ""))}
              />
              {iconType === "Colecciones" && <span className="icon icon-magazine-reader" />}
              {iconType === "Sala de lectura" && <span className="icon icon-mobile-alt" />}
              {iconType === "Podcast" && <span className="icon icon-microphone" />}
            </div>

            <div className="m-category-recommended__body-container__content-info">
              <span className="m-category-recommended__body-container__content-title">
                {item.tituloBanner}
              </span>
              <div className="m-category-recommended__body-container__content-description">
                {item.descripcion !== null &&
                  documentToReactComponents(item.descripcion.json)}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return renderBody();
};

export default CategoryRecommendedBody;
